<template>
  <div class="container mt-3">
    <section class="bg-white p-4">
      <label>
        <p>
          {{ question }}
        </p>
        <small class="mb-3">
          {{ type }}
        </small>
      </label>
      <b-form-group class="mx-auto mb-3">
        <b-form-radio-group
          v-model="selected"
          class="customCheck2"
          button-variant="light"
          :options="options"
          stacked
          buttons
          :disabled="showNextInfo"
        >
        </b-form-radio-group>
      </b-form-group>

      <section v-if="showNextInfo" class="text-center mb-5">
        <span
          v-for="item in message"
          :key="item.id"
          :class="item.isCorrect ? 'text-success' : 'text-danger'"
        >
          <p v-if="item.isCorrect" class="font-weight-bold">
            THE ANSWER IS CORRECT
          </p>
          <p v-else class="font-weight-bold">
            THE ANSWER IS INCORRECT
          </p>
          <p>
            {{ item.question }}
          </p>
          <p class="mb-2">
            {{ item.text }}
          </p>
        </span>
      </section>

      <div class="text-center">
        <small class="">
          Question
          {{ index }}/{{ total }}
        </small>
      </div>
    </section>

    <section class="text-center px-4" v-if="!showNextInfo">
      <b-button
        @click="(showNextInfo = true), setFeedback()"
        variant="info"
        class="my-3"
        block
        :disabled="!selected"
      >
        Done
      </b-button>
      <b-link class="text-muted h-auto" v-if="index == 1" @click="$router.go(-1)">
        Cancel
      </b-link>
    </section>

    <section class="text-center px-4">
      <b-button
        v-if="showNextInfo && index == total"
        @click="$parent.sendData()"
        variant="warning"
        class="my-3 h-auto"
        block
      >
        Finish
      </b-button>

      <b-button
        v-else-if="showNextInfo"
        @click="$parent.count += 1"
        variant="warning"
        class="my-3 h-auto"
        block
      >
        Next
      </b-button>
    </section>
  </div>
</template>
<script>
export default {
  props: {
    options: Array,
    question: String,
    type: String,
    total: Number,
    index: Number,
    id: Number,
  },
  data() {
    return {
      selected: null,
      showNextInfo: null,
      message: [],
      correctAnswer: null,
    };
  },
  methods: {
    setFeedback() {
      this.options.forEach((element) => {
        if (element.value == this.selected) {
          if (element.option_is_correct) {
            this.correctAnswer = true;
            this.message.push({
              id: element.id,
              text: 'Right! This is the answer.',
              question: element.text,
              isCorrect: true,
            });
          } else {
            this.correctAnswer = false;
            this.message.push({
              id: element.id,
              text: element.explanation,
              question: element.text,
              isCorrect: false,
            });
          }
        }
      });
    },
  },
};
</script>
<style lang="scss">
.btn-group,
.btn-group-vertical {
  display: block;
}
.customCheck2 label {
  background-color: #ffffff;
  border-color: transparent !important;
  color: var(--color-dark) !important;
  text-align: left;
  font-size: 1.15em;
  border-radius: 30px !important;
  background-color: var(--color-blue-light) !important;
  padding: 10px 10px 10px 15px;
}
.btn-group-toggle > .btn,
.btn-group-toggle > .btn-group > .btn {
  margin-bottom: 8px !important;
}

.customCheck2 .btn-light:not(:disabled):not(.disabled):active,
.customCheck2 .btn-light:not(:disabled):not(.disabled).active,
.customCheck2 .show > .btn-light.dropdown-toggle {
  color: #f3f4f9 !important;
  background-color: var(--color-main) !important;
}
.customCheck2 .btn:focus,
.btn.focus {
  box-shadow: none !important;
}
.form-group {
  margin-bottom: 0;
}
</style>
